import { message } from '@whalecloud/fdx';
import defaultSettings, { ProSettings } from '@config/defaultSettings';
import { Reducer } from '@/typings/connect.d';
import { getCookie } from '@/utils/utils';

const updateTheme = (primaryColor: string) => {
  // Determine if the component is remounted
  if (!primaryColor) {
    return;
  }
  message.loading('正在切换主题！', 1);
};

const updateColorWeak = (colorWeak: string | undefined) => {
  // document.body.className = colorWeak ?? 'colorWeak'; ??不支持IE
  document.body.className = colorWeak ? 'colorWeak' : '';
};
export interface SettingModelType {
  namespace: string;
  state: ProSettings;
  reducers: {
    getSetting: Reducer<any>;
    changeSetting: Reducer<ProSettings>;
    changeSettingTheme: Reducer<ProSettings>;
    initSettingTheme: Reducer<any>;
    clearSettingTheme: Reducer<any>;
  };
}

const Model: SettingModelType = {
  namespace: 'dxpSetting',
  state: defaultSettings,
  reducers: {
    getSetting(state) {
      const setting: {
        primaryColor?: string;
        colorWeak?: string;
      } = {};
      const urlParams = new URL(window.location.href);
      Object.keys(state).forEach(key => {
        if (urlParams.searchParams.has(key)) {
          const value = urlParams.searchParams.get(key);
          setting[key] = value === '1' ? true : value;
        }
      });
      const { primaryColor, colorWeak } = setting;
      if (state?.primaryColor !== primaryColor) {
        // updateTheme(primaryColor);
      }
      updateColorWeak(colorWeak);
      return {
        ...state,
        ...setting,
      };
    },
    changeSetting(state, { payload }) {
      const urlParams = new URL(window.location.href);
      Object.keys(defaultSettings).forEach(key => {
        if (urlParams.searchParams.has(key)) {
          urlParams.searchParams.delete(key);
        }
      });
      Object.keys(payload).forEach(key => {
        if (key === 'collapse') {
          return;
        }
        let value = payload[key];
        if (value === true) {
          value = 1;
        }
        if (defaultSettings[key] !== value) {
          urlParams.searchParams.set(key, value);
        }
      });
      const { primaryColor, colorWeak, contentWidth } = payload;
      if (state?.primaryColor !== primaryColor) {
        // updateTheme(primaryColor);
      }
      if (state?.contentWidth !== contentWidth && window.dispatchEvent) {
        // eslint-disable-next-line no-undef
        window.dispatchEvent(new Event('resize'));
      }
      updateColorWeak(colorWeak);
      window.history.replaceState(null, 'setting', urlParams.href);
      return {
        ...state,
        ...payload,
      };
    },
    changeSettingTheme(state, { payload }) {
      const { primaryColor } = payload;
      if (state?.primaryColor !== primaryColor) {
        updateTheme(primaryColor);
      }
      return {
        ...state,
        ...payload,
      };
    },
    initSettingTheme(state) {
      // 查询
      const getCurrentSetting = getCookie('SETTING');
      const currentSetting = getCurrentSetting ? JSON.parse(getCurrentSetting) : defaultSettings;
      return {
        ...state,
        ...currentSetting,
      };
    },
    clearSettingTheme(state) {
      // 查询
      return {
        ...state,
        ...defaultSettings,
      };
    },
  },
};

export default Model;
